// 数据概览
export const basicColumns = {
  name: 'tag',
  title: {
    name: '数据概览'
  },
  content: {
    colSpan: 4,
    list: [
      {
        field: 'schNum',
        label: '学校数',
        icon: require('@assets/img/home/home_icon_school@2x.png'),
        value: 0
      },
      {
        field: 'orgNum',
        label: '机构数',
        icon: require('@assets/img/home/icon_mechanism.png'),
        value: 0
      },
      {
        field: 'teaNum',
        label: '老师数',
        icon: require('@assets/img/home/icon_teacher.png'),
        value: 0
      },
      {
        field: 'stuNum',
        label: '学生数',
        icon: require('@assets/img/home/icon_student.png'),
        value: 0
      },
      {
        field: 'courseNum',
        label: '课程数',
        icon: require('@assets/img/home/icon_lesson.png'),
        value: 0
      },
      {
        field: 'courseClassNum',
        label: '课班数',
        icon: require('@assets/img/home/icon_class.png'),
        value: 0
      },
      {
        field: 'tuoguanNum',
        label: '托管数',
        icon: require('@assets/img/home/icon_trusteeship.png'),
        value: 0
      }
    ]
  }
};

// 考勤统计
export const workColumns = {
  name: 'work',
  title: {
    name: '考勤统计',
    leftControl: [
      {
        field: 'WorkType',
        component: 'Tabs'
      },
      {
        field: 'WorkDate',
        component: 'DateSingle'
      }
    ]
  },
  content: {
    numInfo: {
      signNum: 0, // 签到人数
      realSignNum: 0, // 实际签到人数
      notSignNum: 0, // 未签到人数
      leaveNum: 0 // 请假人数
    },
    schList: []
  },
  props: {
    classType: 1,
    startDate: ''
    // endDate: ''
  }
};

// 最受欢迎TOP5
export const top5Columns = {
  name: 'table',
  title: {
    name: '最受欢迎TOP5',
    leftControl: [
      {
        field: 'TableType',
        component: 'Tabs'
      }
    ]
  },
  content: {
    columns: [
      {
        title: '排名',
        type: 'index'
      },
      {
        title: '课程',
        key: 'classroomName'
      },
      {
        title: '所属分类',
        key: 'courseTypeName'
      },
      {
        title: '报名人数',
        key: 'enrollNum'
      }
    ],
    rows: []
  }
};

// 订餐统计
export const mealColumns = {
  name: 'pie',
  title: {
    name: '订餐统计',
    leftControl: [
      {
        field: 'FoodTime',
        component: 'DatePicker'
      }
    ]
  },
  content: {
    columns: ['schoolName', 'offerNum'],
    rows: []
  }
};

// 今日数据
export const dayColumns = {
  name: 'today',
  title: {
    name: '今日数据'
  },
  content: [
    {
      name: '课班',
      children: [
        {
          field: 'teaNum',
          label: '今日上课老师',
          value: 0
        },
        {
          field: 'stuNum',
          label: '今日上课学员',
          value: 0
        },
        {
          field: 'stuAbsentNum',
          label: '今日缺勤学员',
          value: 0
        },
        {
          field: 'stuLeaveNum',
          label: '今日请假学员',
          value: 0
        }
      ]
    },
    {
      name: '托管',
      children: [
        {
          field: 'teaTuoGuanNum',
          label: '今日托管老师',
          value: 0
        },
        {
          field: 'stuTuoGuanNum',
          label: '今日托管学员',
          value: 0
        },
        {
          field: 'stuTgAbsentNum',
          label: '今日缺勤学员',
          value: 0
        },
        {
          field: 'stuTgLeaveNum',
          label: '今日请假学员',
          value: 0
        }
      ]
    }
  ]
};

// 托管概览
export const tuoguanColumns = {
  name: 'tags',
  title: {
    name: '托管概览'
  },
  content: {
    colSpan: 24,
    tuoguanStyle: {
      height: '150px',
      marginRigth: '0px',
      padding: '38px 20px 20px 20px'
    },
    list: []
  },
  typeMap: {
    1: '早托',
    2: '午托',
    3: '晚托'
  }
};

// 课程概览
export const courseColumns = {
  name: 'tags',
  title: {
    name: '课程概览'
  },
  content: {
    colSpan: 8,
    tuoguanStyle: {
      height: '136px',
      marginRight: '20px',
      padding: '30px 20px'
    },
    list: []
  },
  tableModal: {
    columns: [
      {
        title: '课程分类',
        key: 'courseTypeName'
      },
      {
        title: '课程数量',
        key: 'courseNumber'
      },
      {
        title: '开班数量',
        key: 'classNumber'
      },
      {
        title: '报名人数',
        key: 'signUpNumber'
      }
    ],
    rows: []
  }
};

export const cardList = [
  {
    title: '报名人数',
    key: 'bmrs',
    unit: '人'
  },
  {
    title: '报名率',
    unit: '%',
    transform: val => val * 100,
    decimals: 1,
    key: 'bml'
  },
  {
    title: '收款总额',
    unit: '元',
    key: 'payAmount',
    transform: val => val / 100
  },
  {
    title: '退款总额',
    unit: '元',
    key: 'refundAmount',
    transform: val => val / 100
  },
  {
    title: '开设课程数',
    unit: '个',
    key: 'kskcs'
  },
  {
    title: '人均报课数',
    unit: '个',
    decimals: 1,
    key: 'rgbks'
  },
  {
    title: '开班数',
    unit: '个',
    key: 'kbs'
  },
  {
    title: '开班总节次数',
    unit: '节',
    key: 'kbzjcs'
  }
];
